import DefaultArrow from './components/defaultArrow.js';
import Arrow2 from './components/arrow2.js';
import Arrow3 from './components/arrow3.js';
import Arrow4 from './components/arrow4.js';
import Arrow5 from './components/arrow5.js';
import Arrow6 from './components/arrow6.js';
import Arrow7 from './components/arrow7.js';
const ARROWS_DATA = {
    DEFAULT_ARROW: {
        SvgComp: DefaultArrow,
        width: 23,
        height: 39,
    },
    ARROW_2: {
        SvgComp: Arrow2,
        width: 40,
        height: 33,
    },
    ARROW_3: {
        SvgComp: Arrow3,
        width: 25,
        height: 42,
    },
    ARROW_4: {
        SvgComp: Arrow4,
        width: 39,
        height: 11,
    },
    ARROW_5: {
        SvgComp: Arrow5,
        width: 39,
        height: 25,
    },
    ARROW_6: {
        SvgComp: Arrow6,
        width: 26,
        height: 40,
    },
    ARROW_7: {
        SvgComp: Arrow7,
        width: 40,
        height: 33,
    },
};
export default ARROWS_DATA;
//# sourceMappingURL=arrowsIconsData.js.map